/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type GlobalAddressComponent = {
  id?: number
  address?: string
  zip_code?: string
  city?: string
  country?: GlobalAddressComponent.country
  lat?: number
  lon?: number
}
export namespace GlobalAddressComponent {
  export enum country {
    NL = 'NL',
    BE = 'BE',
    DE = 'DE',
  }
}
